export default __webpack_public_path__ + "static/media/trener3.c29db4fe.png";